import { observable, action} from "mobx";
import {post} from "../services/ajax.service";

class NdcPricingStore {
  @observable total_ndc_saving = 0;
  @observable exlcuded_ndc_count = 0;
  @observable individual_ndc = [];
  @observable individual_gpi = [];
  @observable scattered_data = [];
  @observable individual_ndc_savings = [];
  @observable ndc_pharmacies = [];
  @observable high_cost_ndc = 0;
  @observable average_cost = 0;
  @observable url ="/api/v1/insightactions/ndcpricing";


  
  @action getTotalNdcSavings = async data => {
      this.total_ndc_saving = 0;
    try {
      let response = await post(
        `${this.url}/getTotalNdcSavings`,
        data
      );

      this.total_ndc_saving = response.data[0].TOTAL_NDC_SAVINGS;
    } catch (err) {
      console.log(err);
    }
  };
  @action getAverageCost = async data => {
    this.average_cost = 0;
  try {
    let response = await post(
      `${this.url}/getAverageCost`,
      data
    );

    this.average_cost = response.data[0].avg_cost;
  } catch (err) {
    console.log(err);
  }
};
  @action getHighCostNdc = async data => {
    this.high_cost_ndc = 0;
  try {
    let response = await post(
      `${this.url}/getHighCostNdc`,
      data
    );

    this.high_cost_ndc = response.data.length;
  } catch (err) {
    console.log(err);
  }
};

  @action getExcludedNdc = async data => {
    this.exlcuded_ndc_count = 0;
  try {
    let response = await post(
      `${this.url}/getExcludedNdc`,
      data
    );

    this.exlcuded_ndc_count = response.data[0].EXCLUDED_NDC;
  } catch (err) {
    console.log(err);
  }
};

@action getIndividualExcludedNdc = async data => {
    this.individual_ndc = [];
  try {
    let response = await post(
      `${this.url}/getIndividualExcludedNdc`,
      data
    );

    this.individual_ndc = response.data;
  } catch (err) {
    console.log(err);
  }
};

@action getIndividualExcludedGPI = async data => {
  this.individual_gpi = [];
try {
  let response = await post(
    `${this.url}/getIndividualExcludedGPI`,
    data
  );

  this.individual_gpi = response.data;
} catch (err) {
  console.log(err);
}
};

@action getScatterSavingsAndQuantity = async data => {
  this.scattered_data = [];
try {
  let response = await post(
    `${this.url}/getScatterSavingsAndQuantity`,
    data
  );

  this.scattered_data = response.data;
} catch (err) {
  console.log(err);
}
};

@action getIndividualNdcSavings = async data => {
  this.individual_ndc_savings = [];
try {
  let response = await post(
    `${this.url}/getIndividualNdcSavings`,
    data
  );

  this.individual_ndc_savings = response.data;
} catch (err) {
  console.log(err);
}
};

@action getPharmaciesForNDC = async data => {
  this.ndc_pharmacies = [];
try {
  let response = await post(
    `${this.url}/getPharmaciesForNDC`,
    data
  );

  this.ndc_pharmacies = response.data;
} catch (err) {
  console.log(err);
}
};
  
}

export default NdcPricingStore;
